// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__dgCYo","subheader":"ReorderModal_subheader__31ZiJ","listWrap":"ReorderModal_listWrap__1YIo8","inactiveWrap":"ReorderModal_inactiveWrap__29QSy"};